export default "__VITE_PUBLIC_ASSET__95cd5960__"